import { NgModule, ModuleWithProviders } from '@angular/core';
import { DndModule } from 'ngx-drag-drop';

import { FieldsModule } from '../fields/fields.module';
import { LoginModule } from '../login/login.module';
import { SharedModule } from '../shared/shared.module';

import { GettyComponent, EditImageDialog, GettyFilterDialog, ActiveSearchPipe } from './getty.component';
import { GettyService } from './getty.service';
import { GettyWindowComponent } from './getty-window.component';

@NgModule({
    declarations: [ 
        GettyComponent,
        GettyWindowComponent,
        EditImageDialog,
        GettyFilterDialog,
        ActiveSearchPipe
    ],
    imports: [
        DndModule,
        FieldsModule,
        SharedModule,
        LoginModule
    ],
    exports: [
        GettyComponent,
        GettyWindowComponent
    ]
})
export class GettyModule { 
    static forRoot(): ModuleWithProviders<GettyModule> {
        return {
            ngModule: GettyModule,
            providers: [GettyService]
        }
    }
}